import { useTranslation } from 'react-i18next';
import IntegrationsTable from 'pages/integrations/components/integrationTable/IntegrationsTable';
import { IntegrationCategory } from 'models/InternalIntegrationSetting';
import TabHeader from '../../components/tabHeader/TabHeader';

const IntegrationsAnalyticsToolsTab = () => {
  const { t } = useTranslation();

  return (
    <section>
      <TabHeader tabName={t('pageIntegrations.tabNames.analytics-tools')} />
      <IntegrationsTable category={IntegrationCategory.ANALYTICS_TOOLS} />
    </section>
  );
};

export default IntegrationsAnalyticsToolsTab;
